import { actionTypes } from "../action_types";

export const SetChartTitles = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.CHART_TITLE_SET_TITLES,
    payload: data,
  });
};

export const ClearChartTitles = () => (dispatch) => {
  dispatch({
    type: actionTypes.CHART_TITLE_CLEAR_TITLES,
  });
};

export const SetChartBranchCategoryTitle = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.CHART_TITLE_SET_BRANCH_CATEGORIES,
    payload: data,
  });
};

export const SetChartRankingTitle = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.CHART_TITLE_SET_RANKING,
    payload: data,
  });
};

export const SetChartInventoryTargetTitle = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.CHART_TITLE_SET_INVENTORY_TARGET,
    payload: data,
  });
};
export const SetChartCustomerProfilingTitle = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.CHART_TITLE_SET_CUSTOMER_PROFILING,
    payload: data,
  });
};

export const SetChartPackagesTitle = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.CHART_TITLE_SET_PACKAGES,
    payload: data,
  });
};

export const SetChartUnredeemedPawnsTitle = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.CHART_TITLE_SET_UNREDEEMED_PAWN,
    payload: data,
  });
};

export const SetChartSalesAverageTitle = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.CHART_TITLE_SET_SALES_AVERAGE,
    payload: data,
  });
};

export const SetChartSalesActiveTitle = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.CHART_TITLE_SET_SALES_ACTIVE,
    payload: data,
  });
};

export const SetChartSalesExpiredTitle = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.CHART_TITLE_SET_SALES_EXPIRED,
    payload: data,
  });
};
